import {useMutation, useQuery, useQueryClient} from "react-query";
import type {
    InsightTargetPeriodV4 as InsightTargetPeriodApi,
    InsightTargetSelectionUpdateV4 as InsightTargetSelectionUpdateApi,
    InsightTargetsUpdateV4 as InsightTargetsUpdateApi,
} from "../../models/crm-v4";
import {InsightTargetV4Service as CrmTargetsApi} from "../../services/insight-target-v4.service";

const TARGETS_KEY = "crm-insights-v4-targets";
const TARGET_MUTATION_KEY = "crm-insights-v4-target-mutation";

export function useInsightTargets() {
    return useQuery<InsightTargetPeriodApi[]>({
        queryKey: [TARGETS_KEY],
        queryFn: () => CrmTargetsApi.list(),
        refetchOnWindowFocus: false,
    });
}

export function useSaveInsightTargets() {
    const queryClient = useQueryClient();

    return useMutation(
        (update: InsightTargetsUpdateApi) => CrmTargetsApi.save(update),
        {
            mutationKey: [TARGET_MUTATION_KEY],
            onSuccess: saved => {
                queryClient.setQueryData([TARGETS_KEY], saved);
            },
        },
    );
}

export function useSelectInsightTarget() {
    const queryClient = useQueryClient();

    return useMutation(
        (selection: InsightTargetSelectionUpdateApi) => CrmTargetsApi.select(selection),
        {
            mutationKey: [TARGET_MUTATION_KEY],
            onSuccess: saved => {
                queryClient.setQueryData([TARGETS_KEY], saved);
            },
        },
    );
}

export function useRemoveInsightTarget() {
    const queryClient = useQueryClient();

    return useMutation(
        ({from, to}: {from: string; to: string}) => CrmTargetsApi.remove(from, to),
        {
            mutationKey: [TARGET_MUTATION_KEY],
            onSuccess: remaining => {
                queryClient.setQueryData([TARGETS_KEY], remaining);
            },
        },
    );
}
